import { AutogenModelCarrierOfferGenerator, AutogenRowCarrierOfferGenerator } from "./autogen/AutogenModelCarrierOfferGenerator";

export class ModelCarrierOfferGenerator extends AutogenModelCarrierOfferGenerator<RowCarrierOfferGenerator> {
    constructor() {
        super(RowCarrierOfferGenerator);
    }
}

export class RowCarrierOfferGenerator extends AutogenRowCarrierOfferGenerator {
}